import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	children: ReactNode;
	className?: string;
	variant?: 'primary' | 'secondary';
	isLoading?: boolean;
};

const variantClassNames = {
	primary: 'bg-mantang-primary text-mantang-gray-900 disabled:opacity-30',
	secondary:
		'bg-mantang-gray-100 text-mantang-gray-500 disabled:bg-mantang-gray-300 disabled:text-mantang-gray-100',
};

const Button = ({
	children,
	className,
	variant = 'primary',
	isLoading = false,
	disabled,
	...props
}: ButtonProps) => {
	return (
		<button
			type="button"
			{...props}
			disabled={disabled || isLoading}
			className={twMerge(
				'flex h-14 w-full max-w-84 cursor-pointer items-center justify-center rounded-2xl px-4 py-2 font-semibold transition-all duration-150 active:scale-[0.98] disabled:cursor-not-allowed',
				variantClassNames[variant],
				className,
			)}
		>
			{isLoading ? (
				<span className="h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent" />
			) : (
				children
			)}
		</button>
	);
};

export default Button;
